'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/Button.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _react.PropTypes.string,
  handleClick: _react.PropTypes.func,
  disabled: _react.PropTypes.bool,
  children: _bcPropTypes.childrenShape.isRequired,
  loadingText: _bcPropTypes.childrenShape,
  isLoading: _react.PropTypes.bool,
  tagName: _react.PropTypes.string,
  spinnerColor: _react.PropTypes.string,
  spinnerPrimary: _react.PropTypes.bool,
  block: _react.PropTypes.bool,
  flat: _react.PropTypes.bool,
  dataKey: _react.PropTypes.string
};

var Button = function (_BcReactComponent) {
  _inherits(Button, _BcReactComponent);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(Button, [{
    key: 'handleClick',
    value: function handleClick(e) {
      if (this.props.isLoading) {
        e.preventDefault();
        return;
      }
      if (this.props.handleClick) {
        e.preventDefault();
        this.props.handleClick(e);
      }
    }
  }, {
    key: 'renderSpinner',
    value: function renderSpinner() {
      var _props = this.props,
          isLoading = _props.isLoading,
          spinnerColor = _props.spinnerColor,
          spinnerPrimary = _props.spinnerPrimary;

      return isLoading && _react2.default.createElement(_baseIcons.Spinner, { color: spinnerColor, primary: spinnerPrimary });
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      var _props2 = this.props,
          isLoading = _props2.isLoading,
          loadingText = _props2.loadingText,
          children = _props2.children;


      return isLoading ? loadingText && _react2.default.createElement(
        'span',
        { className: 'btn-loading-content' },
        loadingText
      ) : children;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          block = _props3.block,
          flat = _props3.flat,
          dataKey = _props3.dataKey,
          Tag = _props3.tagName,
          props = _objectWithoutProperties(_props3, ['className', 'block', 'flat', 'dataKey', 'tagName']);

      delete props.handleClick;
      delete props.currentPage;
      delete props.spinnerPrimary;
      delete props.isLoading;
      delete props.spinnerColor;
      delete props.loadingText;
      delete props.children;

      return _react2.default.createElement(
        Tag,
        _extends({}, props, {
          onClick: this.handleClick,
          className: Button.getButtonClassName(className, block, flat),
          'data-key': dataKey }),
        this.renderContents(),
        this.renderSpinner()
      );
    }
  }], [{
    key: 'getButtonClassName',
    value: function getButtonClassName() {
      var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var isBlock = arguments[1];
      var isFlat = arguments[2];

      return (0, _classnames2.default)('cp-btn', 'btn', classes, {
        'btn-block': isBlock,
        'btn-flat': isFlat
      });
    }
  }]);

  return Button;
}(_baseBcReactComponent2.default);

Button.propTypes = propTypes;
Button.defaultProps = {
  tagName: 'button'
};
Button.displayName = 'Button';

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/button/components/Button.component.js
// module id = 423
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 15